import React, { useState, useEffect } from 'react';
import ReactQuill from 'react-quill';
import {
    MDBBtn,
    MDBInput,
    MDBCard,
    MDBCardBody,
    MDBRow,
    MDBCol,
    MDBIcon
} from 'mdb-react-ui-kit';

import { defaultPrivacyContent } from "../../utils/DefaultPolicyData"
import { updatePrivacyPolicy, getCustomisablePrivacy } from "../../services/apiServices.js"
import { browserName, browserVersion } from "react-device-detect";
import { logEvent } from '../../services/classApiServices';
import { useAnalytics } from '../../hooks/useAnalytics';

function FlexiblePrivacyPolicy(props) {
    const { toggleShow, onDetailsChange, showAlert } = props;

  const { trackButtonClick } = useAnalytics();
    const [formData, setFormData] = useState({
        title: 'Privacy Policy',
        details: defaultPrivacyContent

    });

    const [errors, setErrors] = useState({});
    const [isSaving, setIsSaving] = useState(false);
    const [apiError, setApiError] = useState(false);

    const handleInputChange = (field, value) => {
        setFormData(prev => ({
            ...prev,
            [field]: value
        }));

        if (errors[field]) {
            setErrors(prev => ({
                ...prev,
                [field]: ''
            }));
        }
    };


    const gymId = JSON.parse(localStorage.getItem("loggedUserInfo"))?.gymid;


    const isHtmlEmpty = (html) => {
        if (!html) return true;
        const textContent = html.replace(/<[^>]*>/g, '').trim();
        return textContent === '';
    };



    console.log("gymId", gymId);

    useEffect(() => {
        async function fetchPrivacyPolicy() {
            const response = await getCustomisablePrivacy(gymId);
            if (!response || response === "false") return;

            const result = await response.json();
            console.log("resultjjjjjjjjjjjjj", result)
            if (result?.title || result?.privacypolicy) {
                setFormData({
                    title: result.title || 'Privacy Policy',
                    details: result.privacypolicy || ''
                });
            }
        }

        fetchPrivacyPolicy();
    }, [gymId]);



    useEffect(() => {

        async function fetchPrivacyPolicy() {
            try {

                const response = await getCustomisablePrivacy(gymId);
                if (!response || response === "false") return;

                const result = await response.json();
                console.log("resultjjjjjjjjjjjjj", result)

                if (result) {
                    const policyDetails = result.privacypolicy || result.privacyPolicy || '';

                    setFormData({
                        title: result.title || 'Privacy Policy',
                        // If the policy details are empty or just HTML tags, use default
                        details: isHtmlEmpty(policyDetails) ? defaultPrivacyContent : policyDetails
                    });
                }
            } catch (error) {
                console.error("Error fetching cancellation policy:", error);

            }
        }

        fetchPrivacyPolicy();
    }, [gymId]);



    useEffect(() => {
        if (onDetailsChange) {
            onDetailsChange(formData.details);
        }
    }, [formData.details, onDetailsChange]);

    const validateForm = () => {
        const newErrors = {};
        if (!formData.title.trim()) newErrors.title = 'Title is required';
        if (!formData.details.trim()) newErrors.details = 'Policy details are required';
        if (isHtmlEmpty(formData.details)) {
            newErrors.details = 'Policy details are required';
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    console.log("gymId", gymId);

    const onSaveButton = async (e) => {
        e?.preventDefault();
        if (!validateForm()) return;

        setIsSaving(true);
        setApiError(false);

        const payload = {
            gymid: gymId,
            title: formData.title,
            details: formData.details
        };

        const userInfo = JSON.parse(localStorage.getItem("loggedUserInfo")) || {};

        const fullName = userInfo.fname && userInfo.lname
            ? `${userInfo.fname} ${userInfo.lname}`
            : userInfo.name || "User";

        const username1 = userInfo.username || userInfo.email || "Guest";
        const gymid = userInfo.gymid || "";
        const ip = localStorage.getItem("ipaddress") || "Unknown IP";
        const browserinfo = `${browserName || "Unknown"}-${browserVersion || "0"}.0.0`;

        const Eventtype = gymid;
        const flag = `Privacy Policy updated successfully(${fullName})`;


        showAlert(flag)

        try {
            const response = await updatePrivacyPolicy(payload, gymId);
            if (response.ok || response.status === 200) {
                toggleShow(false);

                logEvent({ Eventtype, username1, ip, flag, browserinfo, gymid, isclass: true }, gymid);
                await trackButtonClick("FlexiblePrivacyPolicy", "Update_PrivacyPolicy", "staff", {});

            } else {
                setApiError(true);
            }
        } catch (error) {
            console.error("Error updating cancellation policy:", error);
            setApiError(true);
        } finally {
            setIsSaving(false);
        }
        toggleShow(false);
    };

    const handleCancel = () => {
        toggleShow(false);
    };

    return (
        <div className="flexible-cancellation-policy">
            <MDBRow>
                <MDBCol md="12">
                    <MDBCard className="mb-4">
                        <MDBCardBody>
                            <div>
                                <div className="mb-3">
                                    <label className="form-label">
                                        Title
                                    </label>
                                    <MDBInput
                                        value={formData.title}
                                        onChange={(e) => handleInputChange('title', e.target.value)}
                                        invalid={!!errors.title}
                                        validation={errors.title}
                                        required
                                        placeholder="Enter policy title"
                                    />
                                    {errors.title && (
                                        <div className="text-danger mt-1" style={{ fontSize: '0.875rem' }}>
                                            <MDBIcon fas icon="exclamation-triangle" className="me-1" />
                                            {errors.title}
                                        </div>
                                    )}
                                </div>

                                <div className="mb-3">
                                    <label className="form-label">
                                        Content
                                    </label>
                                    <ReactQuill
                                        value={formData.details}
                                        onChange={(value) => handleInputChange('details', value)}
                                    />
                                    {errors.details && (
                                        <div className="text-danger mt-1" style={{ fontSize: '0.875rem' }}>
                                            <MDBIcon fas icon="exclamation-triangle" className="me-1" />
                                            {errors.details}
                                        </div>
                                    )}
                                </div>

                                <div className="modal-footer pb-0">
                                    <MDBBtn
                                        color="secondary"
                                        onClick={handleCancel}
                                        disabled={isSaving}
                                    >
                                        Cancel
                                    </MDBBtn>
                                    <MDBBtn
                                        color="primary"
                                        type="submit"
                                        disabled={isSaving}
                                        onClick={onSaveButton}
                                    >
                                        Save
                                    </MDBBtn>
                                </div>
                            </div>
                        </MDBCardBody>
                    </MDBCard>
                </MDBCol>
            </MDBRow>
        </div>
    );
}

export default FlexiblePrivacyPolicy;






